import type { ComponentType } from 'react';

import {
  CredentialExpiringSoonRenderer,
  getMetaData as getCredentialExpiringSoonMetaData,
} from './CredentialExpiringSoonRenderer';
import {
  FacilityTripRequestedRenderer,
  getMetaData as getFacilityTripRequestedMetaData,
} from './FacilityTripRequestedRenderer';
import {
  PublicTripRequestedRenderer,
  getMetaData as getPublicTripRequestedMetaData,
} from './PublicTripRequestedRenderer';
import {
  TripSubscriptionExpiringSoonRenderer,
  getMetaData as getTripSubscriptionExpiringSoonMetaData,
} from './TripSubscriptionExpiringSoonRenderer';
import type {
  NotificationMetaDataCallback,
  NotificationRendererProps,
} from './types';
import type { NotificationTypeNameEnum } from 'src/common/external/bambi-api/notificationsApi';

type RendererItem = {
  Component: ComponentType<NotificationRendererProps>;
  getMetaData: NotificationMetaDataCallback;
};

export const notificationListRenderers: Partial<
  Record<NotificationTypeNameEnum, RendererItem>
> = {
  credential_expiring_soon: {
    Component: CredentialExpiringSoonRenderer,
    getMetaData: getCredentialExpiringSoonMetaData,
  },
  trip_subscription_expiring_soon: {
    Component: TripSubscriptionExpiringSoonRenderer,
    getMetaData: getTripSubscriptionExpiringSoonMetaData,
  },
  public_trip_requested: {
    Component: PublicTripRequestedRenderer,
    getMetaData: getPublicTripRequestedMetaData,
  },
  facility_trip_requested: {
    Component: FacilityTripRequestedRenderer,
    getMetaData: getFacilityTripRequestedMetaData,
  },
};
